import React, { useState } from 'react';

const RoomAssignmentModal = ({ reservation, onClose, onAssignRoom }) => {
  const [roomNumber, setRoomNumber] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onAssignRoom(reservation.bookingid, roomNumber);
  };

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-gray-800 bg-opacity-50">
      <div className="max-w-full w-[450px] mx-auto p-6 bg-white rounded-lg shadow-lg m-0">
        <h2 className="text-2xl font-semibold text-center mb-6">Assign Room</h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Booking ID Section */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Reservation Number
            </label>
            <input
              type="text"
              value={reservation.orderid}
              readOnly
              disabled
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none"
            />
          </div>

          {/* Room Number Section */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Room Number</label>
            <input
              type="text"
              value={roomNumber}
              placeholder="Enter room number"
              onChange={(e) => setRoomNumber(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none"
              required
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-between gap-4">
            <button
              type="submit"
              className="w-full py-3 bg-black text-white rounded-lg focus:outline-none hover:text-white transition"
            >
              Assign
            </button>
            <button
              type="button"
              onClick={onClose}
              className="w-full py-3 bg-red-500 text-white rounded-lg focus:outline-none hover:text-white transition"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RoomAssignmentModal;
